"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = _interopRequireDefault(require("./core"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Permissions = /*#__PURE__*/function () {
  function Permissions() {
    _classCallCheck(this, Permissions);
  }

  _createClass(Permissions, null, [{
    key: "permissions",
    get: function get() {
      return _core["default"].store.get('core:permissions:permissions');
    },
    set: function set(value) {
      return _core["default"].store.set('core:permissions:permissions', value);
    }
  }, {
    key: "install",
    value: function install() {
      var _this = this;

      if (this.enabled) {
        _core["default"].eventhub.on('core:auth:authenticated', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(authenticated) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // Remove permissions on logout
                    if (authenticated === false) {
                      _this.setPermissions(null);
                    }

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "setPermissions",
    value: function setPermissions() {
      var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.permissions = permissions || [];

      _core["default"].eventhub.emit('core:permissions', this.permissions);
    }
  }, {
    key: "getPermissions",
    value: function () {
      var _getPermissions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var options,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                _context2.prev = 1;
                _context2.t0 = this;
                _context2.next = 5;
                return _core["default"].ws.get('/auth/resource/permissions', _objectSpread({}, options));

              case 5:
                _context2.t1 = _context2.sent;

                _context2.t0.setPermissions.call(_context2.t0, _context2.t1);

                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t2 = _context2["catch"](1);
                this.setPermissions(null);
                throw _context2.t2;

              case 13:
                return _context2.abrupt("return", this.permissions);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 9]]);
      }));

      function getPermissions() {
        return _getPermissions.apply(this, arguments);
      }

      return getPermissions;
    }()
  }, {
    key: "hasPermission",
    value: function hasPermission() {
      var _this2 = this;

      var neededPermissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.enabled === false) {
        console.warn('[core:permissions]', 'Permissions not enabled, so return true');
        return true;
      } // Always false when resource is not authenticated


      if (!_core["default"].auth.authenticated || !_core["default"].auth.resource) {
        return false;
      } // Return false when permissions are empty


      if (!this.permissions || Array.isArray(this.permissions) === false) {
        return false;
      } // Convert neededPermissions to array


      if (typeof neededPermissions === 'string') neededPermissions = [neededPermissions];

      if (!neededPermissions || neededPermissions.length === 0) {
        return true;
      }

      return (neededPermissions || []).every(function (permissions) {
        if (typeof permissions === 'string') permissions = [permissions]; // Check every permission

        return (permissions || []).some(function (permission) {
          return _this2.permissions.includes(permission);
        });
      });
    }
  }]);

  return Permissions;
}();

exports["default"] = Permissions;
Permissions.enabled = true;
Permissions.getPermissionsOnEvent = 'auth';